import { Component, OnInit } from '@angular/core';
import { DiaSemana } from 'src/app/admihair/api/dto/dia-semana';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { AdmihairBaseComponent } from '../../../admihair-base.component';
import { ActivatedRoute } from '@angular/router';
import { ConfiguracaoAgendaEmpresaService } from 'src/app/admihair/service/configuracao-agenda-empresa.service';
import { ConfiguracaoAgendaEmpresa } from 'src/app/admihair/api/dto/configuracao-agenda-empresa';
import { ProfissionalService } from 'src/app/admihair/service/profissional.service';
import { Profissional } from 'src/app/admihair/api/dto/profissional';
import { ConfiguracaoAgendaProfissional } from 'src/app/admihair/api/dto/configuracao-agenda-profissional';
import { ConfiguracaoAgendaProfissionalService } from 'src/app/admihair/service/configuracao-agenda-profissional.service';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-conta-inserir',
  templateUrl: './configurar-agenda.component.html',
  styleUrls: ['./configurar-agenda.component.scss']
})
export class ConfigurarAgendaComponent extends AdmihairBaseComponent implements OnInit {

  dias: DiaSemana[] = [];
  
  diaSselecionadoConfEmpresa?: DiaSemana;
  horaIniioConfEmpresa?: string;
  horaFimConfEmpresa?: string;

  confsEmpresa: ConfiguracaoAgendaEmpresa[] = [];

  profissionaisAgenda: Profissional[] = [];

  profissionaisSelecionadoConfProfissional?: Profissional;
  diaSselecionadoConfProfissional?: DiaSemana;
  horaIniioConfProfissional?: string;
  horaFimConfProfissional?: string;

  confsProfossionais:ConfiguracaoAgendaProfissional[] = [];

  progressoRequisicao: boolean = false;

  horaInicioTime?: string;

  loadingTableProfissionais: boolean = false;
  profissionaisConfigurados: Profissional[] = [];
  profissionalConfiguradoSelecionado?: Profissional;

  constructor(
    private confAgendaEmpresaService: ConfiguracaoAgendaEmpresaService,
    private confAgendaProffisionalService: ConfiguracaoAgendaProfissionalService,
    private profissionalService: ProfissionalService,
    private confirmationService: ConfirmationService,
    private activatedRouter: ActivatedRoute,
    erroService: ErroService,
    storageService: UtilStorageService) {
    super(erroService, storageService)
  }

  ngOnInit(): void {

    this.preencherDiasSemana();
    this.preencherHoraPadrao();
    this.listarConfsEmpresa();
    this.listarProfissionaisAgenda();

    this.listarProfissionaisConfigurados();
  }

  listarConfsEmpresa() {
    this.confAgendaEmpresaService.listarPorEmpresaId(this.getEmpresa().id).subscribe({
      next: (data: ConfiguracaoAgendaEmpresa[]) => {
        this.confsEmpresa = data;        
      },
      error: (err: any) => {
        this.exibirMensagemErro(err);
      }
    });
  }

  listarConfsProfissioanis() {
    if(this.profissionalConfiguradoSelecionado) {
      this.loadingTableProfissionais = true;
      this.confAgendaProffisionalService.listarConfiguracoesPorProfissional(this.getEmpresa().id, this.profissionalConfiguradoSelecionado?.id).subscribe({
        next: (data: ConfiguracaoAgendaProfissional[]) => {
          this.confsProfossionais = data;
          this.loadingTableProfissionais = false;
        },
        error: (err: any) => {
          this.loadingTableProfissionais = false;
          this.exibirMensagemErro(err);
        }
      });
    }
  }

  listarProfissionaisAgenda() {
    this.profissionalService.listarPorEmpresaIdDisponiveisAgenda(this.getEmpresa().id).subscribe({
      next: (data: Profissional[]) => {
        this.profissionaisAgenda = data;                
      },
      error: (err: any) => {
        this.exibirMensagemErro(err);
      }
    });
  }

  listarProfissionaisConfigurados() {
    this.confAgendaProffisionalService.listarProfissionaisConfigurados(this.getEmpresa().id).subscribe({
      next: (data: Profissional[]) => {
        this.profissionaisConfigurados = data;                
      },
      error: (err: any) => {
        this.exibirMensagemErro(err);
      }
    });
  }

  preencherHoraPadrao() {
    this.horaIniioConfEmpresa = '07:00'; 
    this.horaFimConfEmpresa = '19:00'

    this.horaIniioConfProfissional = '07:00'    
    this.horaFimConfProfissional = '19:00'    
  }

  preencherDiasSemana() {
    this.dias = [
      { id: 1, dia: 'Domingo', horaInicio: new Date(), horaFim: new Date() },
      { id: 2, dia: 'Segunda-feira', horaInicio: new Date(), horaFim: new Date() },
      { id: 3, dia: 'Terça-feira', horaInicio: new Date(), horaFim: new Date() },
      { id: 4, dia: 'Quarta-feira', horaInicio: new Date(), horaFim: new Date() },
      { id: 5, dia: 'Quinta-feira', horaInicio: new Date(), horaFim: new Date() },
      { id: 6, dia: 'Sexta-feira', horaInicio: new Date(), horaFim: new Date() },
      { id: 7, dia: 'Sábado', horaInicio: new Date(), horaFim: new Date() },
    ];
  }

  mostarDia(id: number): string {
    let retorno = '';
    for (const item of this.dias) {
      if (id === item.id) {
        retorno = item.dia;
      }
    }
    return retorno;
  }

  salvarConfEmpresa() {
    if (this.diaSselecionadoConfEmpresa && this.horaIniioConfEmpresa && this.horaFimConfEmpresa) {     
      const conf: ConfiguracaoAgendaEmpresa = {
        diaSemanaId: this.diaSselecionadoConfEmpresa.id,
        empresaId: this.getEmpresa().id,
        horaInicio: this.horaIniioConfEmpresa,
        horaFim: this.horaFimConfEmpresa,        
      };
      this.confAgendaEmpresaService.salvar(conf).subscribe({
        next: (data: ConfiguracaoAgendaEmpresa) => {          
          this.exibirMensagemSucesso();
          this.listarConfsEmpresa();
        },
        error: (err: any) => {
          this.exibirMensagemErro(err);
        }
      });
    }
  }

  excluirConfEmpresa(id: number) {
    this.confirmationService.confirm({
      message: 'Tem certeza que seja excluir?',
      header: 'Confirmação',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.confAgendaEmpresaService.excluir(id).subscribe({
          next: (data: void) => {
            this.exibirMensagemSucesso();
            this.listarConfsEmpresa();
          },
          error: (err: any) => {
            this.exibirMensagemErro(err);
          }
        });
      }
    });
    
  }


  salvarConfColaborador() {
    if (this.profissionaisSelecionadoConfProfissional
       && this.diaSselecionadoConfProfissional 
       && this.horaIniioConfProfissional 
       && this.horaFimConfProfissional) {
      const conf: ConfiguracaoAgendaProfissional = {
        profissional: this.profissionaisSelecionadoConfProfissional,
        diaSemanaId: this.diaSselecionadoConfProfissional.id,
        empresaId: this.getEmpresa().id,
        horaInicio: this.horaIniioConfProfissional,
        horaFim: this.horaFimConfProfissional
      };
      this.confAgendaProffisionalService.salvar(conf).subscribe({
        next: (data: ConfiguracaoAgendaProfissional) => {          
          this.exibirMensagemSucesso();
          this.profissionalConfiguradoSelecionado = this.profissionaisSelecionadoConfProfissional;
          this.listarConfsProfissioanis()
        },
        error: (err: any) => {
          this.exibirMensagemErro(err);
        }
      });
    }
  }

  excluirConfProfissional(id: number) {
    this.confirmationService.confirm({
      message: 'Tem certeza que seja excluir?',
      header: 'Confirmação',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.confAgendaProffisionalService.excluir(id).subscribe({
          next: (data: void) => {
            this.exibirMensagemSucesso();
            this.listarConfsProfissioanis();
          },
          error: (err: any) => {
            this.exibirMensagemErro(err);
          }
        });
      }
    });
  }
}
